import type { Adventure } from '../../types'

// Age 5: Math Mix-Up - Addition AND Subtraction
export const mathMixUpAdventure: Adventure = {
  id: 'math-mix-up',
  title: 'Math Mix-Up',
  theme: 'addition',
  targetAge: '5',
  difficulty: 'medium',
  estimatedDuration: 10,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hey math superstar! I'm Tilly! Ready for a mix of adding AND taking away? Let's go!",
      duration: 5
    },
    story1: {
      id: 'story-1',
      tillyLine: "First, let's add! I have 5 red marbles and 3 blue marbles. How many total?",
      duration: 6,
      background: 'number-world'
    },
    choice1: [
      {
        id: 'add-first',
        label: "Add them!",
        tillyLine: "Adding time! 5 plus 3 equals...",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'simple-addition',
      question: '5 + 3 = ?',
      tillyPrompt: 'What is 5 plus 3?',
      options: [
        { id: '7', label: '7', isCorrect: false },
        { id: '8', label: '8', isCorrect: true },
        { id: '9', label: '9', isCorrect: false }
      ],
      num1: 5,
      num2: 3
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Perfect! Now for subtraction. I have 9 stickers and give 4 to friends. How many left?",
      duration: 6,
      background: 'math-forest'
    },
    choice2: [
      {
        id: 'take-away',
        label: "Take away!",
        tillyLine: "Taking away 4 from 9...",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'simple-addition',
      question: '9 - 4 = ?',
      tillyPrompt: '9 take away 4 equals what?',
      options: [
        { id: '4', label: '4', isCorrect: false },
        { id: '5', label: '5', isCorrect: true },
        { id: '6', label: '6', isCorrect: false }
      ],
      num1: 9,
      num2: 4
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "You're amazing at both adding AND subtracting! Ready for the mixed-up challenge?",
        duration: 5,
        background: 'pattern-world'
      },
      quizzes: [
        {
          id: 'challenge-quiz-1',
          type: 'simple-addition',
          question: '6 + 4 = ?',
          tillyPrompt: 'First one: 6 plus 4!',
          options: [
            { id: '9', label: '9', isCorrect: false },
            { id: '10', label: '10', isCorrect: true },
            { id: '11', label: '11', isCorrect: false }
          ],
          num1: 6,
          num2: 4
        } as any,
        {
          id: 'challenge-quiz-2',
          type: 'simple-addition',
          question: '7 - 3 = ?',
          tillyPrompt: 'Now subtract: 7 take away 3!',
          options: [
            { id: '3', label: '3', isCorrect: false },
            { id: '4', label: '4', isCorrect: true },
            { id: '5', label: '5', isCorrect: false }
          ],
          num1: 7,
          num2: 3
        } as any,
        {
          id: 'challenge-quiz-3',
          type: 'simple-addition',
          question: '2 + 5 = ?',
          tillyPrompt: 'Last one: 2 plus 5!',
          options: [
            { id: '6', label: '6', isCorrect: false },
            { id: '7', label: '7', isCorrect: true },
            { id: '8', label: '8', isCorrect: false }
          ],
          num1: 2,
          num2: 5
        } as any
      ]
    },
    reward: {
      tillyLine: "Outstanding! You mastered both adding and subtracting! You're a Math Mix-Up champion!",
      badgeName: 'Math Mix Master',
      badgeIcon: '🧮',
      nextPreview: 'Next time, we\'ll explore bigger numbers!'
    }
  }
}

// Tilly reactions for mixed operations
export const tillyMixCorrect = [
  "That's it! Add or subtract - you got it!",
  "Perfect! You know both operations!",
  "Yes! Math Mix-Up master!",
  "You can do it all! Amazing!",
  "Bingo! Addition, subtraction - easy for you!",
  "Wow! You're a complete math whiz!",
  "Absolutely right! Keep mixing!"
]

export const tillyMixWrong = [
  "Not quite! Check if you need to add or take away!",
  "Almost! Think: more or less?",
  "Good try! Adding makes more, subtracting makes less!",
  "That's not it! What operation are we doing?",
  "Oops! Let's try the other operation!",
  "Not that one! Add or subtract?",
  "Keep trying! You're learning both skills!"
]
